<template>
    <div class="row mt-4">
        <div class="col">
            <div class="card pb-5">
                <div class="card-body">
                    <h5 class="mb-0">Timeline</h5>

                    <div v-if="!events.length" class="alert alert-info my-4">
                        There are no test events to show
                    </div>

                    <div v-else>
                        <div v-for="(event, index) in events" :key="index">
                            <div class="timeline my-2">
                                <div class="timeline-item w-mobile-100"
                                    :class="{
                                        'created' : event.eventType == TestEventType.CREATED,
                                        'assigned' : event.eventType == TestEventType.ASSIGNED || event.eventType == TestEventType.REASSIGNED,
                                        'issued' : event.eventType == TestEventType.ISSUED,
                                        'fasting-completed' : event.eventType == TestEventType.TEST_A_COMPLETED,
                                        'two-hour-completed' : event.eventType == TestEventType.TEST_B_COMPLETED,
                                        'results-received' : event.eventType == TestEventType.RECEIVED || event.eventType == TestEventType.IN_REVIEW,
                                        'marked-complete' : event.eventType == TestEventType.COMPLETED,
                                        'marked-cancelled' : event.eventType == TestEventType.CANCELLED,
                                        'marked-reported' : event.eventType == TestEventType.REPORTED,
                                        'marked-errored' : event.eventType == TestEventType.ERROR,
                                        'marked-failed' : event.eventType == TestEventType.FAILED,
                                        'notification' : event.eventType == TestEventType.NOTIFICATION,
                                        'overridden' : event.eventType == TestEventType.OVERRIDDEN,
                                        'reordered' : event.eventType == TestEventType.REORDERED,
                                        'accepted' : event.eventType == TestEventType.ACCEPTED,
                                        'reordered' : event.eventType == TestEventType.REORDERED,
                                        'has-link-line' : index > 0
                                    }"
                                >
                                    <p class="font-weight-bold mb-1">{{ event.eventTypeText }}</p>
                                    <p v-if="event.eventDate && event.resultDateInvalid !== true" class="text-sm mb-1">{{ event.eventDate | moment("DD/MM/YYYY HH:mm") }}</p>
                                    <p class="font-italic text-sm mb-0 text-center">
                                        <span v-if="event.testLinkId != null" @click="viewTest(event.testLinkId)" class="underlined text-capitalize cursor-pointer">{{ event.testLinkText }}</span>
                                        {{ event.details }}
                                        <a v-if="event.externalLink" :href="event.externalLink" target="_blank" class="d-block underlined cursor-pointer ">{{ event.externalLinkText ?? getDefaultLinkText(event.externalLink) }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TestEventType from '../../Common/enums/TestEventType'
import { mapActions } from 'vuex'
import TestStatus from '../../Common/enums/TestStatus'
export default {
    name: 'TestEventsComponent',

    props: {
        events: Array,
        results: {},
        linkedTestParams: {
            type: Function,
            default: testId => ({ id: testId })
        }
    },

    data () {
        return {
            TestEventType,
            TestStatus
        }
    },

    methods: {
        ...mapActions({
            setShouldRefreshViewTestComponent: 'AppStore/SetShouldRefreshViewTestComponent'
        }),
        async viewTest (testId) {
            await this.$router.push({ name: 'ViewTest', params: this.linkedTestParams(testId) })
            this.setShouldRefreshViewTestComponent(true)
        },
        getDefaultLinkText(linkText){
            if (linkText.includes('royalmail.com')) {
                const pathArray = linkText.split("/");
                return 'Tracking number ' + pathArray.at(-1);
            }
            return 'External Link'
        }
    }
}
</script>
